import { Component } from '@angular/core'
import { BaseCellComponent } from './base-cell.component'
import { NumberDisplayComponent } from '../../number-display/number-display-component'

interface NumberCellComponentProps<D> {
  num: (d: D) => number | null;
  precision?: number;
}

@Component({
  imports: [NumberDisplayComponent],
  styles: `
    :host {
      position: relative;
      span[app-number-display]::ng-deep {
        margin-top: 0;
      }
    }
    `,
  template: `
    @if(params.data){
      <span app-number-display [value]="params.num(params.data)" [precision]="params.precision ?? 8"></span>
    }
  `,
})
export class NumberCellComponent<DATA> extends BaseCellComponent<
  DATA,
  NumberCellComponentProps<DATA>,
  keyof DATA
> {}
